module.exports = __webpack_public_path__ + "img/result-icon.d3910533.png";